export const wizardPostFormHiddenFields: string[] = ['affiliate', 'visitor_id'];

export const wizardPostFormHiddenFieldsWithoutPromocode: string[] = [...wizardPostFormHiddenFields, 'promocode'];
